import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MarkdownModule, MARKED_OPTIONS, MarkedOptions, MarkedRenderer } from 'ngx-markdown';
import { ChatContainerComponent } from '@nimbus-global/features/chat/components/chat-container/chat-container.component';
import { ModalModule } from '@nimbus-library/features/modal/modal.module';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { ChatWidgetComponent } from '@nimbus-global/features/chat/components/chat-widget/chat-widget.component';
import { ChatMessagesComponent } from '@nimbus-global/features/chat/components/chat-messages/chat-messages.component';
import { ChatInputMessageComponent } from '@nimbus-global/features/chat/components/chat-input-message/chat-input-message.component';
import { ChatMessageFormComponent } from '@nimbus-global/features/chat/components/chat-message-form/chat-message-form.component';
import { UIModule } from '@nimbus-global/features/ui/ui.module';
import { NimbusMaterialPageModule } from '@nimbus-library/features/shared/components/material/nimbus-page/nimbus-material-page.module';
import { ChatFormatPipe } from '@nimbus-global/features/chat/components/chat-messages/chat-format.pipe';

@NgModule({
  declarations: [ChatContainerComponent, ChatWidgetComponent, ChatMessagesComponent, ChatInputMessageComponent, ChatMessageFormComponent],
  imports: [
    CommonModule,
    ModalModule,
    MatDialogModule,
    NimbusMaterialPageModule,
    UIModule,
    SharedUIModule,
    ReactiveFormsModule,
    InfiniteScrollDirective,
    TranslateModule,
    ChatFormatPipe,
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useFactory: (): MarkedOptions => {
          const renderer = new MarkedRenderer();
          renderer.link = ({ href, title, tokens }): string => {
            const text = tokens.map((token) => token.raw).join('');
            return `<a href="${href}" target="_blank" rel="noopener noreferrer"${title ? ` title="${title}"` : ''}>${text}</a>`;
          };
          return { renderer };
        },
      },
    }),
  ],
  exports: [ChatContainerComponent, ChatWidgetComponent, ChatInputMessageComponent, ChatMessageFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChatModule {}
